import { all, put, takeEvery, call } from 'redux-saga/effects'
import i18n from 'i18n'

import getMenuData from 'services/menu'
import getRoutes from 'services/router'
import actions from './actions.ts'

export function* GET_DATA() {
  if (i18n.isInitialized !== true) {
    return
  }
  const { adminMenuList, menuList } = yield call(getMenuData)
  const routerData = yield call(getRoutes)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      adminMenuData: adminMenuList,
      menuData: menuList,
      routerData,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.RELOAD, GET_DATA),
    GET_DATA(), // run once on app load to fetch menu data
  ])
}
